import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import {
  getAssignmentsRankingQuery,
  GetAssignmentsRankingQueryResult,
  GetAssignmentsRankingQueryVariables,
} from '../graphql/queries/getAssignmentsRankingQuery';
import { RankingStudent, RankingItem } from '../types';

interface AssignmentsRankingHookInput {
  courseId: string;

  from?: string;
  to?: string;
}

interface AssignmentsRankingHookResult {
  courseId?: string;
  courseName?: string;
  students?: RankingStudent[];
  assignments?: RankingItem[];

  loading: boolean;
  error?: string;
  onRefetchRanking: () => void;
}

export default function useAssignmentsRanking(input: AssignmentsRankingHookInput): AssignmentsRankingHookResult {
  const { courseId, from = '', to = '' } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error, refetch } = useQuery<GetAssignmentsRankingQueryResult, GetAssignmentsRankingQueryVariables>(
    getAssignmentsRankingQuery,
    {
      variables: {
        courseId,
        queryParams: { startDate: from, endDate: to },
      },
      onError: showErrorNotification,
    }
  );

  return {
    ...data?.assignmentRankingPayload,
    loading,
    error: getErrorMessage({ error }),

    onRefetchRanking: refetch,
  };
}
